import React from 'react';
import MarketplacePracticeLocation from '../MarketplacePracticeLocation/MarketplacePracticeLocation';
import { EntityLocationInfo } from '../../../../slices/profiles-data-slice/models/entity-location-info';
import './MarketplacePracticeLocationsTable.scss';
import { useFormikContext, getIn } from 'formik';
import { PracticeFocus } from '../../../../utils/constants/PracticeFocus.enum';

interface MarketplacePracticeLocationsTableProps {
    locations: EntityLocationInfo[];
    fieldPrefix: string;
    setFormFieldValue(name: string, value: any): void;
    removeLocation(locationIndex: number): void;
    isEditable?: boolean;
}

export const MarketplacePracticeLocationsTable: React.FC<
    MarketplacePracticeLocationsTableProps
> = (props: MarketplacePracticeLocationsTableProps) => {
    const { isEditable = true } = props;
    const { values } = useFormikContext();

    const isOtherPracticeFocusInputVisible = () => {
        const locations = getIn(
            values,
            `${props.fieldPrefix}`
        ) as EntityLocationInfo[];

        return locations?.some(
            (location) =>
                location.practiceFocusType?.toString() ===
                PracticeFocus.Other?.toString()
        );
    };

    return (
        <div className="practice-locations-table">
            <table className="table locations-table">
                <thead>
                    <tr>
                        <th>Number of locations</th>
                        <th>Street Address</th>
                        <th>City</th>
                        <th>State</th>
                        <th style={{ width: '90px' }}>Zip</th>
                        <th>Location Type</th>
                        <th>DBA Name</th>
                        <th style={{ width: '100px' }}>FTE DVMs</th>
                        <th>Service Focus</th>
                        <th hidden={!isOtherPracticeFocusInputVisible()}>
                            Specify Service Focus
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {props.locations.map((location, index) => (
                        <MarketplacePracticeLocation
                            key={location.id}
                            location={location}
                            index={index}
                            fieldPrefix={props.fieldPrefix}
                            setFormFieldValue={props.setFormFieldValue}
                            removeLocation={props.removeLocation}
                            isEditable={isEditable}
                            isOtherPracticeFocusColumnVisible={isOtherPracticeFocusInputVisible()}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default MarketplacePracticeLocationsTable;
